// src/components/copilot/components/ChatMessage.jsx
import { Assistant } from "@mui/icons-material";
import { Avatar, Box, Chip, Typography } from "@mui/material";
import { memo } from "react";
import MessageBubble from "./MessageBubble";
import StructuredDataForm from "./StructuredDataForm";

const ChatMessage = memo(({ message, onSaveStructuredData, onSendMessage }) => {
  const { role, content, structuredData, schema, className, quickActions } =
    message;

  const handleQuickAction = (trigger) => {
    const actionMessages = {
      entity: "Help me add a business entity",
      experience: "Add investment experience",
      bankAccount: "Add a bank account",
      documents: "What documents do I need to upload?",
    };

    const message = actionMessages[trigger];
    if (message && onSendMessage) {
      onSendMessage(message);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: role === "user" ? "flex-end" : "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexGrow: 1,
          maxWidth: "85%",
          justifyContent: "inherit",
        }}
      >
        {/* Avatar for assistant/system messages */}
        {role === "assistant" && (
          <Avatar
            sx={{
              width: "32px",
              height: "32px",
              bgcolor: "primary.main",
            }}
            variant="rounded"
          >
            <Assistant sx={{ fontSize: "17px" }} />
          </Avatar>
        )}
        {role === "system" && (
          <Avatar
            sx={{
              width: "32px",
              height: "32px",
              bgcolor: "success.main",
            }}
            variant="rounded"
          >
            ✓
          </Avatar>
        )}

        {/* Message bubble */}
        <MessageBubble role={role} fullWidth={!!structuredData}>
          <Typography
            variant="body2"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {content || "..."}
          </Typography>

          {/* Quick action chips */}
          {quickActions && quickActions.length > 0 && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
              {quickActions.map((action, i) => (
                <Chip
                  key={i}
                  label={action.label}
                  onClick={() => handleQuickAction(action.trigger)}
                  variant="outlined"
                  size="small"
                  color="primary"
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      bgcolor: "primary.50",
                    },
                  }}
                />
              ))}
            </Box>
          )}

          {/* Inline structured data form */}
          {structuredData && schema && (
            <StructuredDataForm
              data={structuredData}
              schema={schema}
              className={className}
              onSave={onSaveStructuredData}
            />
          )}
        </MessageBubble>
      </Box>
    </Box>
  );
});

ChatMessage.displayName = "ChatMessage";

export default ChatMessage;
